// extracted by mini-css-extract-plugin
module.exports = {"container":"General_container__3Z_aH","containerHead":"General_containerHead__KWQjk","numbers":"General_numbers__3UGYy"};